import axios from 'axios';
import api from '../Api/api';

export const trackPageVisit = async (pageUrl) => {
  try {
    // Get IP address from a free IP service
    let ipAddress = 'unknown';
    
    try {
      const ipResponse = await axios.get('https://api.ipify.org?format=json');
      ipAddress = ipResponse.data.ip;
    } catch (ipError) {
      console.error('Error getting IP:', ipError);
    }

    // Send visitor data with IP
    await api.post('/api/user/save-visitor', {
      page_url: pageUrl,
      ip_address: ipAddress
    });
  } catch (error) {
    console.error('Error tracking visitor:', error);
  }
};